import { autoinject } from 'aurelia-framework';
import { DialogController } from "aurelia-dialog";
import { WebApiService } from "../../services/web-api-service";
import { BusyService } from "../../services/busy-service";
import { PageMessageService } from "../../services/page-message-service";
import { Contact } from "../../models/contact";
import 'jquery';
import 'notify';
import { SecurityService } from '../../services/security-service';

@autoinject
export class ReportParametersDialog {
    constructor(
        protected controller: DialogController,
        private securityService: SecurityService,
        private busyService: BusyService,
        private pageMessageService: PageMessageService,
        private api: WebApiService) {
    }


    reportName: string;
    fileName: string;
    mills: Array<any> = [];
    millId: string;
    format: string = "PDF";
    isAllMillsSelected: boolean;


    activate(settings) {
        this.reportName = settings.reportName;
        this.format = settings.format || this.format;
        this.fileName = settings.fileName || this.reportName;

        this.loadMills();
    }

    loadMills() {
        this.busyService.on();
        return this.api.get("Registration", "GetDivisions")
            .then((result) => {
                let mills = JSON.parse(result.response);
                const userDivisions = this.securityService.user.millCodes;
                if (userDivisions.length > 0) {
                    mills = mills.filter(o => userDivisions.indexOf(o.millId) > -1);
                }
                this.mills = mills;
            })
            .finally(() => {
                this.busyService.off();
            });
    }

    runReport(report) {
       
        var reportFragment = encodeURIComponent(this.reportName + "&millId=" + this.millId);
        window.open("/Report/Download?fileName=" + encodeURIComponent(this.fileName) + "&reportFragment=" + reportFragment + "&format=" + this.format);

    }


}